import { explicitMaybe } from '@execonline-inc/decoders';
import { array, dateISO, Decoder, field, number, string, succeed } from 'jsonous';
import { readonlyArray } from '../../../../Decoders';
import { resourceDecoder } from '../../../../Resource/Decoders';
import {
  ChatMetadata,
  ChatMetadataResource,
  ProductLicense,
  UpdatedChatMetadata,
  UpdatedChatMetadataResource,
} from './Types';

export const productLicenseDecoder: Decoder<ProductLicense> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('quantityAvailable', field('quantity_available', number))
  .assign('startOn', field('start_on', dateISO))
  .assign('endOn', field('end_on', dateISO));

export const chatMetadataDecoder: Decoder<ChatMetadata> = succeed({})
  .assign('defaultLicenseId', field('default_license_id', explicitMaybe(number)))
  .assign('productLicenses', field('product_licenses', readonlyArray(productLicenseDecoder)));

export const chatMetadataResourceDecoder: Decoder<ChatMetadataResource> =
  resourceDecoder(chatMetadataDecoder);

export const updatedChatMetadataDecoder: Decoder<UpdatedChatMetadata> = succeed({})
  .assign('productLicenseId', field('product_license_id', number))
  .assign(
    'stillAvailableRecommendationIds',
    field('still_available_recommendation_ids', explicitMaybe(array(number))),
  );

export const updatedChatMetadataResourceDecoder: Decoder<UpdatedChatMetadataResource> =
  resourceDecoder(updatedChatMetadataDecoder);
